<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack" data-testid="go-back-btn">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <div class="container">
      <!-- <PageTitle :title="pageText.pageTitle" :subtitle="pageText.formText" /> -->
      <div class="auth-header">
            <div class="auth-heading">
                <h1>Blocked Pharmacies</h1>
                <p class="auth-subtext"></p>
            </div>
            <div class="brand-icon">
                <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
            </div>
        </div>
      <div class="blocked_pharmacy_wrapper" v-if="blockedPharmacyListLoading">
        <div class="loading_wrapper text-center">
          loading...
        </div>
      </div>
      <div v-else>
        <div class="blocked_pharmacy_wrapper" data-testid="blocked-pharmacies-list" v-if="pharmacies.length > 0">
          <template v-for="pharmacy in pharmacies" :key="pharmacy.id">
            <div class="pharmacy_card" data-testid="blocked-pharmacy-card">
              <div class="image_text_comp" data-testid="blocked-pharmacy">
                <div class="image_wrapper">
                  <el-avatar :size="'small'" :shape="'square'" :src="pharmacy.image" v-if="pharmacy.image" />
                  <el-avatar :size="'small'" :shape="'square'" icon="el-icon-user-solid" v-else></el-avatar>
                </div>
                <div class="text_wrapper">
                  <div class="main_text">{{ pharmacy.name }}</div>
                  <div class="additional_text">
                    {{ $filters.addressText(pharmacy.address) }}
                  </div>
                </div>
                <el-button class="unblock-btn" type="primary" size="small" data-testid="unblock-pharmacy-btn"
                  @click="unBlockPharmacy(pharmacy)">Unblock</el-button>
              </div>
            </div>
          </template>
        </div>
        <div data-testid="no-blocked-pharmacies" v-else>
          <div class="no_data_wrapper">
            <div class="no_data_text">No blocked pharmacies</div>
          </div>
        </div>
      </div>
      <div class="bg-overlay"></div>
    </div>
    <div class="background-circles">
        <div class="circle circle-2"></div>
        <div class="circle circle-1"></div>
        <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
    </div>
  </div>
</template>
    
<script>
import { ElMessage, ElMessageBox } from "@/components/Vendor/Element";
import { onMounted, inject, onBeforeMount, ref } from "vue";
import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
// import PageTitle from "@/components/PageTitle/PageTitle.vue";
import SvgIcon from '@/components/Svg/SvgIcon.vue';

addIcons({
  "arrow-back-outline": arrowBackOutline,
});

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    SvgIcon
  },
  directives: {},
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    const routeName = $route.name;
    const pharmacies = ref({});
    const blockedPharmacyListLoading = ref(true);
    const setPageClassGlobal = inject("setPageClassGlobal");
    const goBack = () => {
      $router.push({
        name: "profile",
      });
    };

    onMounted(() => {
      setPageClassGlobal("global_profile_block_pharmacies");
    });

    onBeforeMount(async () => {
      if ($store.getters.locumBlockedPharmacies.length > 0) {
        pharmacies.value = $store.getters.locumBlockedPharmacies;
        blockedPharmacyListLoading.value = false;
        return;
      }
      const response = await $store.dispatch("GET_LOCUM_BLOCKED_PHARMACIES");
      console.log("🚀 ~ onBeforeMount ~ response:", response)
      pharmacies.value = response.data.data;
      blockedPharmacyListLoading.value = false;
    });

    const unBlockPharmacy = (pharmacy) => {
      ElMessageBox.confirm(
        "Are you sure you want to unblock this pharmacy?",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }
      )
        .then(() => {
          $store
            .dispatch("BLOCK_PHARMACY", {
              pharmacyId: pharmacy.id,
              type: 'unblock'
            })
            .then((response) => {
              if (response.data.status) {
                pharmacies.value = pharmacies.value.filter((item) => item.id !== pharmacy.id);
                ElMessage({
                  type: "success",
                  message: `Pharmacy unblocked successfully`,
                });
              } else {
                ElMessage({
                  type: "error",
                  message: `Error while unblocking pharmacy`,
                });
              }
            });
        })
        .catch(() => { });
    }

    const pageText = {
      pageTitle: "Blocked Pharmacies",
      formText: "",
    };

    return {
      goBack,
      routeName,
      pharmacies,
      unBlockPharmacy,
      blockedPharmacyListLoading,
      pageText,
    };
  },
};
</script>

<style scoped lang="scss">
.blocked_pharmacy_wrapper {
  margin-top: 5px;
}
.pharmacy_card {
  background-color: white;
  margin-bottom: 10px;
  padding: 16px;
  cursor: pointer;
  border-radius: 10px;
  filter: drop-shadow(0px 4px 14px rgba(0, 0, 0, 0.08));
}
</style>
